import { MenuItem } from '../../services/dataService';

const CACHE_PREFIX = 'cafelawn_public_menu_';
const CACHE_TTL_MS = 5 * 60 * 1000; // 5 minutes

type CachedPayload = {
  items: MenuItem[];
  savedAt: number;
};

export function readPublicMenuCache(tenantId: string): MenuItem[] | null {
  try {
    const raw = sessionStorage.getItem(CACHE_PREFIX + tenantId);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as CachedPayload;
    if (!parsed?.items || !Array.isArray(parsed.items)) return null;
    if (Date.now() - parsed.savedAt > CACHE_TTL_MS) {
      sessionStorage.removeItem(CACHE_PREFIX + tenantId);
      return null;
    }
    return parsed.items;
  } catch {
    return null;
  }
}

export function writePublicMenuCache(tenantId: string, items: MenuItem[]): void {
  try {
    const payload: CachedPayload = { items, savedAt: Date.now() };
    sessionStorage.setItem(CACHE_PREFIX + tenantId, JSON.stringify(payload));
  } catch {
    // ignore quota / private mode
  }
}
